import apiClient from '@/services/axios'

export async function patch(id, changeGuestListItemArrivalStateCommand) {

  var response = await apiClient.patch(process.env.VUE_APP_MARCOM_API_BASE_URL + `/admin/guest-list-items/${id}`, changeGuestListItemArrivalStateCommand);
  if (response) {
    console.log(response);
    return response.data;
  }

  throw new Error('Unable to update a guest list item.')
}
